import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * @title Dialog with header, scrollable content and actions
 */
@Component({
  selector: 'dialog-content-example',
  templateUrl: './delete-confirm.component.html',
  styleUrls: ['./delete-confirm.component.css'],
  standalone: false,
})
export class DeleteConfirmComponent {
  constructor(public dialogRef: MatDialogRef<DeleteConfirmComponent>) {}

  delete() {
    this.dialogRef.close(true);
  }

  noDelete() {
    this.dialogRef.close(false);
  }
}
